import { Col, Row } from "reactstrap";
import { FontsTitle } from "../../../Constants/Constants";
import { FontsAndBadgeData } from "../../../Data/Bonus/Elements";

const FontsAndBadge = () => {
  return (
    <section>
      <Row>
        {FontsAndBadgeData.map((item, index) => (
          <Col md="6" sm="12" key={index}>
            <div className="element-card">
              <div className="element-card-header heading">
                <h2>{FontsTitle}</h2>
              </div>
              <div className="element-card-body typography">
                {item.color.map((color, index) => (
                  <div className={`badge badge-${color} fonts font_label`} key={index}>
                    label-{color}
                  </div>
                ))}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default FontsAndBadge;
